import React from 'react';
import './Overlays.css'

export default function DoublingPanel({ gs, myId, send }) {
  const isBiddingTeam = myId % 2 === gs.bid_winner % 2;
  const isDoublingPhase = gs.phase === 'doubling';
  const isRedoublingPhase = gs.phase === 'redoubling';

  const bidWinnerName = gs.players?.[gs.bid_winner]?.name ?? 'Bid Winner';
  
  if (isDoublingPhase) {
    if (isBiddingTeam) {
      return (
        <div className="phase-panel">
          <h3>Doubling · Double</h3>
          <p>Waiting for defenders to decide if they want to double the stakes…</p>
          <div className="bid-current">{gs.current_bid}</div>
          <p style={{ color: '#94a3b8', fontSize: '0.85rem' }}>Current Bid by <strong>{bidWinnerName}</strong></p>
        </div>
      );
    }

    const hasPassed = gs.doubling_passed?.[myId];

    return (
      <div className="phase-panel">
        <h3>Double?</h3>
        <p>Would you like to double the <strong>match points</strong> for this round?</p>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 15, margin: '15px 0' }}>
          <div className="bid-current" style={{ margin: 0 }}>{gs.current_bid}</div>
          <span className="multiplier-badge" style={{ fontSize: '1.2rem', padding: '5px 12px' }}>x2 Stakes</span>
        </div>
        
        <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
          <button className="btn btn-primary" style={{ flex: 1, backgroundColor: '#dc2626' }} onClick={() => send('double', {})}>
            Double
          </button>
          {!hasPassed && (
            <button className="btn btn-secondary" style={{ flex: 1 }} onClick={() => send('pass_double', {})}>
              Pass
            </button>
          )}
        </div>
        {hasPassed && <p style={{ marginTop: 8, fontSize: '0.8rem', color: '#94a3b8' }}>You passed. Waiting for teammate...</p>}
      </div>
    );
  }

  if (isRedoublingPhase) {
    if (!isBiddingTeam) {
      const doublerName = gs.players?.[gs.doubler_id]?.name ?? 'Defender';
      return (
        <div className="phase-panel">
          <h3>Redoubling · Redouble</h3>
          <p><strong>{doublerName}</strong> has doubled! Waiting for <strong>{bidWinnerName}</strong> to decide on a redouble…</p>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 15, margin: '15px 0' }}>
            <div className="bid-current" style={{ margin: 0 }}>{gs.current_bid}</div>
            <span className="multiplier-badge" style={{ fontSize: '1.2rem', padding: '5px 12px' }}>x2 Stakes</span>
          </div>
        </div>
      );
    }

    const hasPassed = gs.redoubling_passed?.[myId];

    return (
      <div className="phase-panel">
        <h3>Redouble?</h3>
        <p>Defenders have doubled! Do you want to redouble to <strong>x4 match points</strong>?</p>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 15, margin: '15px 0' }}>
          <div className="bid-current" style={{ margin: 0 }}>{gs.current_bid}</div>
          <span className="multiplier-badge x4" style={{ fontSize: '1.2rem', padding: '5px 12px' }}>x4 Stakes</span>
        </div>
        
        <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
          <button className="btn btn-primary" style={{ flex: 1, backgroundColor: '#b91c1c' }} onClick={() => send('redouble', {})}>
            Redouble
          </button>
          {!hasPassed && (
            <button className="btn btn-secondary" style={{ flex: 1 }} onClick={() => send('pass_redouble', {})}>
              Pass
            </button>
          )}
        </div>
        {hasPassed && <p style={{ marginTop: 8, fontSize: '0.8rem', color: '#94a3b8' }}>You passed. Waiting for teammate...</p>}
      </div>
    );
  }

  return null;
}
